<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- First name -->
    <client-first-name-field
      v-model="$attrs.client.first_name"
      :error="$attrs.errors.client.first_name"
    />

    <!-- Middle name -->
    <client-middle-name-field
      v-model="$attrs.client.middle_name"
      :error="$attrs.errors.client.middle_name"
    />

    <!-- Last name -->
    <client-last-name-field
      v-model="$attrs.client.last_name"
      :error="$attrs.errors.client.last_name"
    />

    <!-- Phone -->
    <phone-field
      v-model="$attrs.client.phone"
      :error="$attrs.errors.client.phone"
    />

    <!-- Contract number -->
    <contract-number-field
      v-model="$attrs.client.contract_number"
      :error="$attrs.errors.client.contract_number"
    />

    <!-- Apartment -->
    <apartment-field
      v-model="$attrs.client.apartment"
      :error="$attrs.errors.client.apartment"
      v-show="!(formType == 'add' && $attrs.client.apartment)"
    />

    <!-- Rate plan -->
    <rate-plan-field
      v-model="$attrs.client.rate_plan"
      :error="$attrs.errors.client.rate_plan"
    />

    <!-- Discount -->
    <discount-field
      v-model="$attrs.client.discount"
      :error="$attrs.errors.client.discount"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import clientFirstNameField from '@/components/forms/client/fields/ClientFirstName'
import clientMiddleNameField from '@/components/forms/client/fields/ClientMiddleName'
import clientLastNameField from '@/components/forms/client/fields/ClientLastName'
import phoneField from '@/components/forms/client/fields/Phone'
import contractNumberField from '@/components/forms/client/fields/ContractNumber'
import apartmentField from '@/components/forms/client/fields/Apartment'
import ratePlanField from '@/components/forms/client/fields/RatePlan'
import discountField from '@/components/forms/client/fields/Discount'

export default {
  name: 'client-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    clientFirstNameField,
    clientMiddleNameField,
    clientLastNameField,
    phoneField,
    contractNumberField,
    apartmentField,
    ratePlanField,
    discountField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClientBlankForm.vue?5fcf7e50